import axios from 'axios'

const initBusinessMaps = function() {

  var marker;
  var map;
  var styles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":"61"},{"weight":"1.12"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"simplified"},{"color":"#1b262e"},{"lightness":"0"}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#52606a"},{"lightness":"0"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.province","elementType":"labels","stylers":[{"lightness":"-37"}]},{"featureType":"administrative.locality","elementType":"labels","stylers":[{"lightness":"-7"}]},{"featureType":"administrative.neighborhood","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"labels","stylers":[{"lightness":"-18"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#52606a"},{"lightness":"0"}]},{"featureType":"landscape.natural","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#52606a"},{"lightness":"0"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#0a0b0c"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#0a0b0c"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#0a0b0c"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#23272a"},{"lightness":19}]},{"featureType":"transit.line","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"transit.station","elementType":"labels","stylers":[{"saturation":"-94"},{"visibility":"simplified"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#ff0000"},{"lightness":"68"}]},{"featureType":"transit.station","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#1b262e"},{"lightness":"0"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]}];


  axios.get('/businesses/business-maps.json')
	.then(function(response) {
		return response.data;
	}).then(initBusinessMap);

  function initBusinessMap(data) {

    data.markers.forEach(createMap);

  }

  function createMap(marker) {

  	if ((typeof marker.lat == 'number') && (typeof marker.lng == 'number')) {

  		var map = new google.maps.Map(document.getElementById('map-'+marker.slug),
  		{
  				height: 200,
  				zoom: 15,
  				draggable: false,
  				scrollwheel: false,
  				disableDefaultUI: true,
  				streetViewControl: false,
  				mapTypeControl: false,
  				center: {lat: marker.lat + .001, lng: marker.lng}, // the + .001 centers the pin vertically
  				styles: styles
  			}
  		);

  	  var marker = new google.maps.Marker({
  	    position: { lat: marker.lat, lng: marker.lng },
  	    map: map,
  	    icon: '/locations/map-pins/pin-' + marker.categorySlug + '.svg',
  	    slug: marker.slug,
  			categorySlug: marker.categorySlug

  	  });

  		markers.push(marker);
  		marker.setMap(map);
    }
  }
}

initBusinessMaps();

// export {initBusinessMaps};



// WEBPACK FOOTER //
// ./scripts/init-business-maps.js